<template>
  <div v-if="visible" class="benefitcode-low-stock-banner">
    <mdb-row class="w-100 align-items-center m-0">
      <mdb-col>
        <mdb-icon icon="exclamation-triangle" class="mr-2" />
        {{ $t("benefitcode_low_stock_warning", {
             title: lowestGroup.benefit_title,
             name: lowestGroup.name,
             remaining: lowestGroup.remaining
           }) }}
      </mdb-col>
      <mdb-col col="auto">
        <mdb-icon icon="times" class="benefitcode-low-stock-close" @click.native="dismiss" />
      </mdb-col>
    </mdb-row>
  </div>
</template>

<script>
import { mdbRow, mdbCol, mdbIcon } from "mdbvue";

export default {
  name: "BenefitCodeLowStockBanner",
  components: {
    mdbRow,
    mdbCol,
    mdbIcon
  },
  data: () => ({
    visible: false,
    lowestGroup: { benefit_title: "", name: "", remaining: 0 },
    benefitcodes: [],
    benefitcodesPath: "/1.0/front/benefitcodes",
    dismissKey: "benefitcode_low_stock_dismissed",
  }),
  methods: {
    dismiss() {
        this.visible = false;
        sessionStorage.setItem(this.dismissKey, "1");
    },
    checkLowStock() {
      if (!this.$store.getters.getToken || sessionStorage.getItem(this.dismissKey)) {
        return;
      }
      this.$http
        .get(this.benefitcodesPath)
        .then((response) => {
          if (response.status == 200) {
            this.benefitcodes = response.data.benefitcodes;
            this.lowestGroup = this.benefitcodes.reduce(
              (acc, curr) => Number(curr.remaining) < Number(acc.remaining) ? curr : acc,
              { benefit_title: "", name: "", remaining: Infinity }
            );
            this.visible = true;
          } else if (response.status == 401) {
            this.$root.$emit("session_failed");
          }
        })
        .catch((error) => {
          window.__logAxiosErrorIfDebug(error, {
            context: "BenefitCodeLowStockBanner.vue - checkLowStock",
          });
          this.$root.$emit("session_failed");
          return error;
        });
    }
  },
  mounted() {
    this.checkLowStock();
  }
};
</script>

<style>
.benefitcode-low-stock-banner {
  position: fixed;
  left: 250px;
  right: 0;
  bottom: 0;
  z-index: 1050; /* SideNavin/Navbarin yläpuolelle */
  background-color: #ffc107; /* huomioväri, esim. warning-keltainen */
  color: #283c46;
  padding: 12px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
  box-shadow: 0 -2px 6px rgba(0,0,0,0.15);
}
.benefitcode-low-stock-close {
  cursor: pointer;
}
</style>